module.exports = __webpack_public_path__ + "img/921_page_rebuild1.0efc3e47.png";